
import { WebNovel, Chapter } from "./types";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TextGenerateEffect } from "@/components/ui/text-generate-effect";

interface WebNovelContentProps {
  novel: WebNovel;
  chapter: Chapter;
  currentPage: number;
  totalPages: number;
  isFlipping: boolean;
  flipPage: (direction: 'next' | 'prev') => void;
  getCurrentPageContent: () => string[];
}

export function WebNovelContent({
  novel,
  chapter,
  currentPage,
  totalPages,
  isFlipping,
  flipPage,
  getCurrentPageContent
}: WebNovelContentProps) {
  return (
    <div className="lg:col-span-2">
      <Card className="p-6 md:p-8 relative bg-card rounded-lg border">
        <h2 className="text-2xl font-bold mb-6">{chapter.title}</h2>
        
        <div className={`min-h-[50vh] transition-opacity duration-300 ${isFlipping ? 'opacity-0' : 'opacity-100'}`}>
          {getCurrentPageContent().map((paragraph, index) => (
            <TextGenerateEffect 
              key={index} 
              words={paragraph} 
              className="mb-4 font-normal"
              filter={false}
              duration={0.5}
            />
          ))}
        </div>
        
        <div className="flex justify-between mt-8">
          <Button
            variant="outline"
            onClick={() => flipPage('prev')}
            disabled={currentPage <= 0}
          >
            <ChevronLeft className="h-4 w-4 mr-2" />
            Anterior
          </Button>
          
          <span className="text-sm text-muted-foreground self-center">
            Página {currentPage + 1} de {totalPages}
          </span>
          
          <Button
            variant="outline"
            onClick={() => flipPage('next')}
            disabled={currentPage >= totalPages - 1}
          >
            Próximo
            <ChevronRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </Card>
    </div>
  );
}
